// Centralized SEO metadata for category, brand, and deal pages


export const CATEGORY_SEO_CONFIG = [
  {
    names: [],
    title: "Wholesale Building Materials Suppliers in UAE | Electrical & Industrial Products",
    description:
      "Explore premium building materials and industrial supplies in UAE including electrical, ventilation, and construction solutions from trusted brands."
  },

  // ================= ELECTRICAL =================

  {
    names: ["Electrical"],
    title: "Electrical Equipment Suppliers in Dubai & UAE | Industrial Solutions",
    description:
      "Discover high-quality electrical equipment in Dubai and UAE for residential, commercial, and industrial applications with reliable performance."
  },

  {
    names: ["Electrical", "Fan"],
    title: "Industrial & Ceiling Fans in UAE | Energy Efficient Ventilation Solutions",
    description:
      "Shop durable ceiling, exhaust, and industrial fans in UAE designed for powerful airflow and energy-efficient performance."
  },

  {
    names: ["Electrical", "Fan", "Blower"],
    title: "Industrial Air Blowers in UAE | High Performance Ventilation Systems",
    description:
      "Powerful industrial blowers in UAE for ventilation, cooling, and heavy-duty airflow applications in commercial and industrial spaces."
  },

  {
    names: ["Electrical", "Fan", "Blower Duct Accessories"],
    title: "Blower Duct Accessories UAE | Ventilation Fittings & Components",
    description:
      "High-quality blower duct accessories in UAE for efficient airflow systems, ventilation setups, and industrial installations."
  },

  {
    names: ["Electrical", "Fan", "Blower Heavy Duty"],
    title: "Heavy Duty Blowers UAE | Industrial Air Ventilation Equipment",
    description:
      "High-performance heavy-duty blowers in UAE designed for continuous industrial ventilation and demanding airflow environments."
  },

  {
    names: ["Electrical", "Fan", "Blower Inline"],
    title: "Inline Duct Blowers UAE | Efficient Airflow Ventilation Systems",
    description:
      "Inline duct blowers in UAE for smooth airflow in residential, commercial, and industrial ventilation systems."
  },

  {
    names: ["Electrical", "Fan", "Blower Portable"],
    title: "Portable Air Blowers UAE | Lightweight Industrial Ventilation Fans",
    description:
      "Portable blowers in UAE offering flexible, lightweight, and efficient ventilation for construction and on-site applications."
  },

  {
    names: ["Electrical", "Fan", "Bracket"],
    title: "Mounting Brackets UAE | Durable Support for Electrical Installations",
    description:
      "Strong and durable mounting brackets in UAE for secure installation of fans, blowers, and electrical equipment."
  },

  {
    names: ["Electrical", "Fan", "Ceiling 60x60 Fan"],
    title: "60x60 Ceiling Fans UAE | Compact & Efficient Air Circulation",
    description:
      "Energy-efficient 60x60 ceiling fans in UAE designed for compact spaces with strong and consistent airflow."
  },

  {
    names: ["Electrical", "Fan", "Ceiling Decorative Fan"],
    title: "Decorative Ceiling Fans UAE | Stylish & Quiet Air Solutions",
    description:
      "Elegant decorative ceiling fans in UAE combining modern design with quiet and efficient cooling performance."
  },

  {
    names: ["Electrical", "Fan", "Ceiling Ordinary Fan"],
    title: "Ordinary Ceiling Fans UAE | Reliable Home Cooling Solutions",
    description:
      "Affordable and reliable ceiling fans in UAE designed for long-lasting performance and smooth air circulation."
  },

  {
    names: ["Electrical", "Fan", "Circomatic Heavy Duty"],
    title: "Circomatic Heavy Duty Fans UAE | Industrial Ventilation Systems",
    description:
      "High-performance Circomatic heavy-duty fans in UAE for industrial and large-area ventilation requirements."
  },

  {
    names: ["Electrical", "Fan", "Circomatic Light Duty"],
    title: "Circomatic Light Duty Fans UAE | Compact Air Ventilation Fans",
    description:
      "Efficient light-duty Circomatic fans in UAE ideal for small spaces and general ventilation needs."
  },

  {
    names: ["Electrical", "Fan", "Exhaust"],
    title: "Exhaust Fans UAE | Industrial & Commercial Ventilation Systems",
    description:
      "High-performance exhaust fans in UAE for kitchens, bathrooms, offices, and industrial ventilation systems."
  },

  {
    names: ["Electrical", "Fan", "Exhaust – Auto Shutter"],
    title: "Auto Shutter Exhaust Fans UAE | Dust-Proof Ventilation Systems",
    description:
      "Automatic shutter exhaust fans in UAE designed for efficient airflow and protection from dust and insects."
  },

  {
    names: ["Electrical", "Fan", "Exhaust – Cooker Hood"],
    title: "Cooker Hood Exhaust Fans UAE | Modern Kitchen Ventilation",
    description:
      "Stylish cooker hood exhaust systems in UAE for effective smoke extraction and kitchen ventilation."
  },

  {
    names: ["Electrical", "Fan", "Exhaust – Duct Fan"],
    title: "Duct Exhaust Fans UAE | High Efficiency Air Ventilation",
    description:
      "Powerful duct exhaust fans in UAE suitable for residential, commercial, and industrial airflow systems."
  },

  {
    names: ["Electrical", "Fan", "Exhaust – Grille"],
    title: "Exhaust Fan Grilles UAE | Durable Ventilation Covers",
    description:
      "Durable exhaust grilles in UAE designed for smooth airflow and protection of ventilation systems."
  },

  {
    names: ["Electrical", "Fan", "Exhaust – Heavy Duty"],
    title: "Heavy Duty Exhaust Fans UAE | Industrial Air Ventilation",
    description:
      "Industrial-grade heavy-duty exhaust fans in UAE built for continuous high-performance ventilation."
  },

  {
    names: ["Electrical", "Fan", "Exhaust – Hose"],
    title: "Exhaust Hoses UAE | Flexible Industrial Air Ducting",
    description:
      "Flexible and durable exhaust hoses in UAE for industrial air transfer and ventilation systems."
  },

  {
    names: ["Electrical", "Fan", "Exhaust – Light Duty"],
    title: "Light Duty Exhaust Fans UAE | Energy Efficient Ventilation",
    description:
      "Energy-saving light-duty exhaust fans in UAE for small rooms, kitchens, and office ventilation."
  },

  {
    names: ["Electrical", "Fan", "Exhaust – Pressure"],
    title: "High Pressure Exhaust Fans UAE | Industrial Air Systems",
    description:
      "High-pressure exhaust fans in UAE designed for strong airflow and demanding industrial applications."
  },

  {
    names: ["Electrical", "Fan", "Exhaust – Round"],
    title: "Round Exhaust Fans UAE | Compact Air Ventilation Solutions",
    description:
      "Compact round exhaust fans in UAE offering efficient airflow in space-saving designs."
  },

  {
    names: ["Electrical", "Fan", "Flush System Electrical"],
    title: "Flush System Electrical Products UAE | Reliable Installations",
    description:
      "Durable flush system electrical products in UAE for safe and efficient installation solutions."
  },

  {
    names: ["Electrical", "Fan", "Flush Side Inlet"],
    title: "Flush Side Inlet Systems UAE | Efficient Water Flow Solutions",
    description:
      "High-quality flush side inlet products in UAE ensuring smooth flow and reliable installation."
  },

  {
    names: ["Electrical", "Fan", "Knife"],
    title: "Industrial Knives UAE | Precision Cutting Tools",
    description:
      "Sharp and durable industrial knives in UAE designed for precision cutting in various applications."
  },

  {
    names: ["Electrical", "Fan", "Lamp"],
    title: "LED Lamps UAE | Energy Efficient Lighting Solutions",
    description:
      "Energy-efficient LED lamps in UAE for residential, commercial, and industrial lighting applications."
  },

  {
    names: ["Electrical", "Fan", "Lamp", "Ball Lamp - LED"],
    title: "LED Ball Lamps UAE | Decorative Energy Saving Lighting",
    description:
      "Stylish LED ball lamps in UAE offering long-lasting, energy-efficient lighting for all spaces."
  },

  {
    names: ["Electrical", "Fan", "Lamp", "Big Lamp - LED"],
    title: "High Lumen LED Lamps UAE | Bright Industrial Lighting",
    description:
      "Powerful LED lamps in UAE designed for high brightness and large-area illumination."
  },

  {
    names: ["Electrical", "Fan", "Lamp", "Spot Lamp"],
    title: "LED Spot Lamps UAE | Focused Lighting Solutions",
    description:
      "Versatile LED spot lamps in UAE ideal for accent lighting and focused illumination."
  },

  {
    names: ["Electrical", "Fan", "Lamp", "Tube Lamp"],
    title: "LED Tube Lights UAE | Commercial Lighting Solutions",
    description:
      "Energy-efficient LED tube lights in UAE for offices, warehouses, and commercial spaces."
  },

  {
    names: ["Electrical", "Fan", "Light Fitting"],
    title: "Lighting Fixtures UAE | Industrial & Commercial Solutions",
    description:
      "Premium lighting fittings in UAE designed for homes, offices, and industrial installations."
  },

  {
    names: ["Electrical", "Fan", "Light Fitting", "BATTEN FITTING – LED GLOW SERIES"],
    title: "LED Batten Lights UAE | Energy Efficient Lighting Fixtures",
    description:
      "LED batten fittings in UAE offering bright, efficient, and modern lighting solutions."
  },

  {
    names: ["Electrical", "Fan", "Light Fitting", "BULK HEAD"],
    title: "Bulkhead Lights UAE | Durable Indoor & Outdoor Lighting",
    description:
      "Strong and durable bulkhead lights in UAE suitable for indoor and outdoor applications."
  },

  {
    names: ["Electrical", "Fan", "Light Fitting", "CONTROL GEAR"],
    title: "Electrical Control Gear UAE | Safe Lighting Systems",
    description:
      "Reliable electrical control gear in UAE ensuring safe and efficient lighting operation."
  },

  {
    names: ["Electrical", "Fan", "Light Fitting", "LED FLOOD LIGHT"],
    title: "LED Flood Lights UAE | Outdoor Industrial Lighting",
    description:
      "High-performance LED flood lights in UAE for outdoor, industrial, and commercial lighting."
  },

  {
    names: ["Electrical", "Fan", "Light Fitting", "PANEL LIGHT – 60 X 60"],
    title: "60x60 LED Panel Lights UAE | Modern Ceiling Lighting",
    description:
      "Sleek and energy-efficient 60x60 LED panel lights in UAE for offices and interiors."
  },

  {
    names: ["Electrical", "Fan", "Light Fitting", "PANEL LIGHT – ROMEESA SERIES"],
    title: "Romeesa LED Panel Lights UAE | Modern Lighting Design",
    description:
      "Stylish Romeesa series LED panel lights in UAE for commercial and residential spaces."
  },

  {
    names: ["Electrical", "Fan", "Light Fitting", "PANEL LIGHT – SWAN SERIES"],
    title: "Swan Series LED Panel Lights UAE | Energy Efficient Lighting",
    description:
      "Durable Swan series panel lights in UAE offering modern and efficient illumination."
  },

  {
    names: ["Electrical", "Fan", "Light Fitting", "RECHARGEABLE – FLASH LIGHT"],
    title: "Rechargeable Flashlights UAE | Portable Emergency Lighting",
    description:
      "Bright rechargeable flashlights in UAE ideal for emergencies, outdoor use, and backup lighting."
  },

  {
    names: ["Electrical", "Fan", "Light Fitting", "ROPE LIGHT"],
    title: "LED Rope Lights UAE | Decorative Lighting Solutions",
    description:
      "Flexible LED rope lights in UAE for decoration, ambience, and creative lighting designs."
  },

  {
    names: ["Electrical", "Power Tools"],
    title: "Power Tools UAE | Industrial & Construction Equipment",
    description:
      "High-quality power tools in UAE designed for construction, industrial, and DIY applications."
  },

  {
    names: ["Electrical", "Power Tools", "Cutting Disc"],
    title: "Cutting Discs UAE | Durable Industrial Cutting Tools",
    description:
      "Strong and precise cutting discs in UAE for metal, wood, and industrial cutting tasks."
  },

  {
    names: ["Electrical", "Power Tools", "Electrical Drill"],
    title: "Electric Drills UAE | Professional Construction Tools",
    description:
      "Reliable electric drills in UAE built for precision, power, and long-lasting performance."
  },

  {
    names: ["Electrical", "Power Tools", "Saw Blade - Wood"],
    title: "Wood Saw Blades UAE | Precision Cutting Tools",
    description:
      "Sharp and durable wood saw blades in UAE designed for smooth and accurate cutting."
  },

  {
    names: ["Electrical", "Power Tools", "Power Tools Accessories"],
    title: "Power Tool Accessories UAE | Industrial Tool Enhancements",
    description:
      "Essential power tool accessories in UAE to improve performance and durability."
  },

  {
    names: ["Electrical", "Power Tools", "Hammer Drill Bit"],
    title: "Hammer Drill Bits UAE | Heavy Duty Drilling Tools",
    description:
      "Strong hammer drill bits in UAE designed for concrete, masonry, and industrial drilling."
  },

  {
    names: ["Electrical", "Power Tools", "Screw Driver Bit"],
    title: "Screwdriver Bit Sets UAE | Precision Tool Accessories",
    description:
      "Durable screwdriver bit sets in UAE for professional and DIY applications."
  },
{
  names: ["Electrical", "Power Tools", "Saw Blade - Wood"],
  title: "Wood Saw Blades UAE Supplier | Novex Power Tools | Buraq Star Trading LLC",
  description: "Buy premium wood saw blades in UAE. High-quality Novex cutting blades for woodworking, construction, and industrial applications with long-lasting durability."
},
{
  names: ["Electrical", "Power Tools", "Power Tools Accessories"],
  title: "Power Tools Accessories UAE | Novex Tools Supplier | Buraq Star Trading LLC",
  description: "Shop professional power tools accessories in UAE. Improve performance and lifespan of drills, saws, and cutting tools with durable Novex products."
},
{
  names: ["Electrical", "Power Tools", "Hammer Drill Bit"],
  title: "Hammer Drill Bits UAE Supplier | Heavy Duty Drill Bits | Novex Tools",
  description: "High-performance hammer drill bits in UAE for concrete, masonry, and industrial drilling. Strong, durable, and precision engineered tools."
},
{
  names: ["Electrical", "Power Tools", "Screw Driver Bit"],
  title: "Screwdriver Bits Set UAE | Precision Power Tool Accessories | Novex",
  description: "Buy screwdriver bits sets in UAE. Durable, precise, and ideal for professional construction, assembly, and DIY applications."
},

{
  names: ["Electrical", "Switchgear"],
  title: "Switchgear Supplier UAE | Electrical Distribution Systems | Buraq Star Trading",
  description: "Reliable switchgear products in UAE for safe electrical distribution in residential, commercial, and industrial installations."
},
{
  names: ["Electrical", "Switchgear", "MCB"],
  title: "MCB Supplier UAE | Miniature Circuit Breakers | Electrical Safety Protection",
  description: "High-quality MCBs in UAE for circuit protection. Safe, durable, and essential for electrical safety in homes and industries."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories"],
  title: "Wiring Accessories UAE Supplier | Electrical Fittings & Components",
  description: "Premium wiring accessories in UAE for safe and efficient electrical installation across residential and commercial projects."
},

{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "BELL - ALARM (WIRING ACCESSORIES (ELECTRICAL))"],
  title: "Alarm Bells UAE Supplier | Electrical Safety Accessories | Industrial Alert Systems",
  description: "Reliable alarm bells in UAE for safety alerts and industrial signaling. Durable electrical wiring accessories for all environments."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "BELL - BIRD"],
  title: "Bird Bells UAE Supplier | Electrical Signaling Devices",
  description: "Durable bird bells in UAE for home and industrial signaling applications. High-quality and long-lasting performance."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "BELL - CHIME"],
  title: "Chime Bells UAE | Door Bell Systems | Home & Office Electrical Accessories",
  description: "Premium chime bells in UAE with clear sound output. Ideal for residential, office, and commercial door systems."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "BELL - INTERCOM"],
  title: "Intercom Bell Systems UAE | Communication & Security Devices",
  description: "Reliable intercom bells in UAE for communication and security systems in residential and commercial buildings."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "BELL - MUSICAL"],
  title: "Musical Door Bells UAE | Decorative Electrical Accessories",
  description: "Stylish musical bells in UAE offering decorative sound solutions for homes, offices, and commercial spaces."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "BELL - TELEPHONE"],
  title: "Telephone Bells UAE Supplier | Electrical Communication Accessories",
  description: "High-quality telephone bells in UAE designed for reliable alert and communication systems."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "BELL - VIDEO"],
  title: "Video Door Bell UAE | Smart Security Door Systems",
  description: "Smart video door bells in UAE for modern home security, monitoring, and communication systems."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "BELL - WIRELESS"],
  title: "Wireless Door Bells UAE | Smart Home Bell Systems",
  description: "Easy-to-install wireless door bells in UAE with long range and reliable performance for homes and offices."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "BELL - WIRELESS (BLUETOOTH SPEAKER)"],
  title: "Bluetooth Wireless Door Bells UAE | Smart Audio Bell Systems",
  description: "Modern wireless door bells in UAE with Bluetooth speaker functionality for smart homes and offices."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "FLOOR - DISTRIBUTION BOX"],
  title: "Floor Distribution Box UAE | Electrical Power Distribution Systems",
  description: "Durable floor distribution boxes in UAE for safe and organized electrical power management systems."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "TORONTO - SWITCH"],
  title: "Electrical Switches UAE | Toronto Switch Supplier | Modern Wiring Solutions",
  description: "Stylish and durable electrical switches in UAE suitable for residential, commercial, and industrial installations."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "TRAILING SOCKET - CABLE REEL"],
  title: "Cable Reel UAE Supplier | Trailing Socket Extension Systems",
  description: "Safe and durable cable reels and trailing sockets in UAE for flexible power distribution solutions."
},
{
  names: ["Electrical", "Switchgear", "Wiring Accessories", "TRUNKING"],
  title: "Electrical Trunking UAE | Cable Management Systems Supplier",
  description: "High-quality electrical trunking in UAE for safe cable management in homes, offices, and industries."
},

/* ================= HARDWARE ================= */

{
  names: ["Hardware"],
  title: "Hardware Supplier UAE | Construction & Industrial Tools | Buraq Star Trading",
  description: "Wholesale hardware supplier in UAE offering high-quality tools, fittings, and construction materials."
},
{
  names: ["Hardware", "CHISEL"],
  title: "Chisel Supplier UAE | Woodworking & Metal Cutting Tools",
  description: "Durable chisels in UAE for woodworking, carving, and industrial metalworking applications."
},
{
  names: ["Hardware", "DRAWER SLIDES"],
  title: "Drawer Slides UAE Supplier | Furniture Hardware Accessories",
  description: "Smooth and durable drawer slides in UAE for furniture, cabinets, and modular systems."
},
{
  names: ["Hardware", "HINGES"],
  title: "Door Hinges UAE Supplier | Furniture & Cabinet Hardware",
  description: "Strong and durable hinges in UAE for doors, cabinets, and furniture installations."
},
{
  names: ["Hardware", "SCREWS"],
  title: "Screws Supplier UAE | Fastening Hardware Solutions",
  description: "High-quality screws in UAE for construction, furniture, and industrial fastening applications."
},

/* ================= SANITARY ================= */

{
  names: ["Sanitary"],
  title: "Sanitary Products UAE Supplier | Bathroom & Plumbing Materials",
  description: "Wholesale sanitary products in UAE including bathroom fittings, plumbing accessories, and drainage systems."
},
{
  names: ["Sanitary", "BATHROOM ACCESSORIES"],
  title: "Bathroom Accessories UAE Supplier | Modern Sanitary Fittings",
  description: "Stylish bathroom accessories in UAE designed for modern homes, hotels, and commercial spaces."
},
{
  names: ["Sanitary", "SOAP HOLDER"],
  title: "Soap Holder UAE Supplier | Bathroom Accessories",
  description: "Durable soap holders in UAE for clean and organized bathroom storage solutions."
},
{
  names: ["Sanitary", "TOWEL RACK"],
  title: "Towel Rack UAE Supplier | Bathroom Storage Solutions",
  description: "Strong and stylish towel racks in UAE for organized and modern bathroom setups."
},
{
  names: ["Sanitary", "CERAMIC CLOSET"],
  title: "Ceramic Closet UAE Supplier | Bathroom Sanitary Ware",
  description: "High-quality ceramic closets in UAE offering durability, hygiene, and modern bathroom design."
},
{
  names: ["Sanitary", "Washdown"],
  title: "Washdown Toilet UAE Supplier | Sanitary Ware Systems",
  description: "Reliable washdown toilets in UAE designed for hygiene, durability, and efficient flushing systems."
},
 {
  names: ["Sanitary", "Drainer"],
  title: "Bathroom & Kitchen Drainers Suppliers in UAE | Buraq Star Trading",
  description: "Buy high-quality bathroom and kitchen drainers in UAE from Buraq Star Trading. Durable, corrosion-resistant drainage solutions for homes and commercial spaces."
},
{
  names: ["Sanitary", "Floor Drainer (Line)"],
  title: "Floor Drainers & Linear Drain Systems in UAE | Buraq Star Trading",
  description: "Shop premium floor and linear drainers in UAE. Strong, long-lasting drainage systems for bathrooms, kitchens, and industrial applications."
},
{
  names: ["Sanitary", "DRAINER (SANITARY)"],
  title: "Sanitary Drainers Suppliers in UAE | Buraq Star Trading",
  description: "High-quality sanitary drainers for bathrooms and kitchens. Durable, rust-resistant drainage solutions for residential and commercial use in UAE."
},
{
  names: ["Sanitary", "Hose - Magic Pipe"],
  title: "Flexible Magic Pipe & Hose Suppliers UAE | Buraq Star Trading",
  description: "Buy flexible magic pipes and hoses in UAE. Ideal for bathroom and kitchen plumbing connections with long-lasting durability and leak resistance."
},
{
  names: ["Sanitary", "FLUSH SYSTEM (SANITARY)"],
  title: "Flush Systems & Toilet Flush Kits UAE | Buraq Star Trading",
  description: "Premium flush systems in UAE for toilets and bathrooms. Efficient, durable, and suitable for residential and commercial sanitary installations."
},
{
  names: ["Sanitary", "Flot Valve"],
  title: "Float Valves for Flush Tanks UAE | Buraq Star Trading",
  description: "High-quality float valves for water tanks and flush systems in UAE. Reliable water control solutions for residential and industrial use."
},
{
  names: ["Sanitary", "Flush"],
  title: "Toilet Flush Valves Suppliers UAE | Buraq Star Trading",
  description: "Durable flush valves for toilets in UAE. Efficient water flow control solutions for homes, offices, and commercial buildings."
},
{
  names: ["Sanitary", "Flush Button"],
  title: "Flush Buttons for Toilets UAE | Buraq Star Trading",
  description: "Stylish and durable flush buttons in UAE. Perfect for modern bathroom designs with smooth and reliable operation."
},
{
  names: ["Sanitary", "Flush Tank"],
  title: "Flush Tanks Suppliers in UAE | Buraq Star Trading",
  description: "High-quality flush tanks in UAE. Durable and efficient water storage solutions for residential and commercial bathrooms."
},
{
  names: ["Sanitary", "GARDEN (SANITARY)"],
  title: "Garden Hoses & Outdoor Plumbing UAE | Buraq Star Trading",
  description: "Buy garden hoses and sanitary outdoor fittings in UAE. Durable irrigation and water supply solutions for outdoor use."
},
{
  names: ["Sanitary", "Adapter - PVC"],
  title: "PVC Pipe Adapters Suppliers UAE | Buraq Star Trading",
  description: "Durable PVC adapters in UAE for plumbing systems. Ideal for bathroom, kitchen, and garden pipe connections."
},
{
  names: ["Sanitary", "HOSE (SANITARY)"],
  title: "PVC Shower Hose Suppliers UAE | Buraq Star Trading",
  description: "Flexible PVC shower hoses in UAE. Strong, leak-proof, and ideal for bathroom and sanitary plumbing connections."
},
{
  names: ["Sanitary", "MIXER"],
  title: "Bathroom Mixers Suppliers UAE | Buraq Star Trading",
  description: "Premium bathroom mixers in UAE. Stylish, durable, and perfect for sinks, basins, and bath installations."
},
{
  names: ["Sanitary", "Basin (Mixer)"],
  title: "Basin Mixer Taps UAE | Buraq Star Trading",
  description: "High-quality basin mixers in UAE. Durable and modern designs for residential and commercial bathroom use."
},
{
  names: ["Sanitary", "Bath"],
  title: "Bath Mixer Taps Suppliers UAE | Buraq Star Trading",
  description: "Stylish bath mixers in UAE. Durable and efficient water control solutions for bathrooms and hotels."
},
{
  names: ["Sanitary", "Sink (Mixer)"],
  title: "Kitchen Sink Mixer Taps UAE | Buraq Star Trading",
  description: "Premium kitchen sink mixers in UAE. Durable, modern, and ideal for residential and commercial kitchens."
},
{
  names: ["Sanitary", "Wall Sink"],
  title: "Wall Mounted Sink Mixers UAE | Buraq Star Trading",
  description: "High-quality wall sink mixers in UAE. Durable plumbing solutions for bathrooms and kitchens."
},
{
  names: ["Sanitary", "PIPE"],
  title: "Sanitary Pipes Suppliers in UAE | Buraq Star Trading",
  description: "Durable sanitary pipes in UAE. Ideal for plumbing, drainage, and water supply systems in homes and industries."
},
{
  names: ["Sanitary", "SHOWER (SANITARY)"],
  title: "Shower Systems Suppliers UAE | Buraq Star Trading",
  description: "Premium shower systems in UAE. Stylish and durable solutions for residential, hotel, and commercial bathrooms."
},
{
  names: ["Sanitary", "TAP"],
  title: "Bathroom Taps Suppliers UAE | Buraq Star Trading",
  description: "High-quality bathroom taps in UAE. Durable, stylish, and suitable for basins, sinks, and bath setups."
},
{
  names: ["Sanitary", "WIRING ACCESSORIES (SANITARY)"],
  title: "Sanitary Wiring Accessories UAE | Buraq Star Trading",
  description: "Safe and durable wiring accessories for sanitary installations in UAE. Reliable electrical solutions for bathrooms and plumbing systems."
},
 // Tools
{
  names: ["Tools"],
  title: "Hand Tools & Power Tools Suppliers in UAE | Dubai | Buraq Star Trading | Novex",
  description: "Shop premium hand tools and power tools in UAE from Buraq Star Trading. Durable, professional-grade tools for construction, industrial, and DIY applications."
},
{
  names: ["Tools", "Hand Tools"],
  title: "Hand Tools Suppliers in Dubai & UAE | Buraq | Novex | Cavil | Zilco",
  description: "Discover high-quality hand tools in Dubai and UAE. Durable, reliable tools for construction, maintenance, repair, and professional use."
},
{
  names: ["Tools", "Hand Tools", "AVIATION SNIP"],
  title: "Aviation Snips Suppliers in UAE | Metal Cutting Tools Dubai | Buraq Star Trading",
  description: "Buy durable aviation snips in UAE. Perfect for cutting sheet metal, wires, and precision industrial applications with high accuracy."
},
{
  names: ["Tools", "Hand Tools", "CABLE TESTER"],
  title: "Cable Testers Suppliers in Dubai UAE | Electrical Testing Tools | Buraq Star Trading",
  description: "Shop reliable cable testers in UAE. Ensure safe and accurate electrical testing, wiring inspection, and troubleshooting for all projects."
},
{
  names: ["Tools", "Hand Tools", "HAMMER"],
  title: "Hammers Suppliers in UAE | Construction Hand Tools Dubai | Buraq Star Trading",
  description: "High-quality hammers in UAE for construction, woodworking, and DIY tasks. Durable, ergonomic, and long-lasting performance tools."
},
{
  names: ["Tools", "Hand Tools", "HAND RIVETER"],
  title: "Hand Riveters Suppliers in UAE | Rivet Tools Dubai | Buraq Star Trading",
  description: "Buy strong and durable hand riveters in UAE. Ideal for metal fastening, fabrication, and industrial repair applications."
},
{
  names: ["Tools", "Hand Tools", "MEASURING TAPE"],
  title: "Measuring Tapes Suppliers in UAE | Construction Tools Dubai | Buraq Star Trading",
  description: "Accurate measuring tapes in UAE for construction, carpentry, and industrial use. Durable, precise, and easy to use."
},
{
  names: ["Tools", "Hand Tools", "PIPE CUTTER"],
  title: "Pipe Cutters Suppliers in UAE | Plumbing Tools Dubai | Buraq Star Trading",
  description: "High-quality pipe cutters in UAE for plumbing, electrical, and industrial applications. Clean, precise, and durable cutting tools."
},
{
  names: ["Tools", "Hand Tools", "PLIER - CABLE CUTTER"],
  title: "Cable Cutter Pliers Suppliers in UAE | Electrical Tools Dubai | Buraq Star Trading",
  description: "Durable cable cutter pliers in UAE for electrical work. Perfect for cutting wires, cables, and installation tasks."
},
{
  names: ["Tools", "Hand Tools", "PLIER - COMBINATION"],
  title: "Combination Pliers Suppliers in UAE | Hand Tools Dubai | Buraq Star Trading",
  description: "Versatile combination pliers in UAE for gripping, twisting, and cutting. Ideal for professional and DIY applications."
},
{
  names: ["Tools", "Hand Tools", "PLIER - END CUTTER"],
  title: "End Cutter Pliers Suppliers in UAE | Cutting Tools Dubai | Buraq Star Trading",
  description: "Precision end cutter pliers in UAE for wires, nails, and small metal components. Strong, durable, and long-lasting."
},
{
  names: ["Tools", "Hand Tools", "PLIER - GROOVE JOINT"],
  title: "Groove Joint Pliers Suppliers in UAE | Plumbing Tools Dubai | Buraq Star Trading",
  description: "Adjustable groove joint pliers in UAE for plumbing, gripping, and mechanical repair applications."
},
{
  names: ["Tools", "Hand Tools", "RULER SQUARE"],
  title: "Ruler Squares Suppliers in UAE | Measuring Tools Dubai | Buraq Star Trading",
  description: "Precision ruler squares in UAE for woodworking, construction, and measurement accuracy in professional work."
},
{
  names: ["Tools", "Hand Tools", "SCREWDRIVER - PHILIPS"],
  title: "Philips Screwdrivers Suppliers in UAE | Hand Tools Dubai | Buraq Star Trading",
  description: "Durable Philips screwdrivers in UAE for DIY, industrial, and professional fastening applications."
},
{
  names: ["Tools", "Hand Tools", "SCREWDRIVER - SLOTTED"],
  title: "Slotted Screwdrivers Suppliers in UAE | Hand Tools Dubai | Buraq Star Trading",
  description: "Reliable slotted screwdrivers in UAE for home, office, and industrial repair and installation work."
},
{
  names: ["Tools", "Hand Tools", "SCREWDRIVER SET - P+S"],
  title: "Screwdriver Sets Suppliers in UAE | P+S Tools Dubai | Buraq Star Trading",
  description: "Complete screwdriver sets in UAE for professional and DIY use. Durable, versatile, and high-performance tools."
},
{
  names: ["Tools", "Hand Tools", "SILICON GUN"],
  title: "Silicon Guns Suppliers in UAE | Sealant Tools Dubai | Buraq Star Trading",
  description: "High-quality silicon guns in UAE for sealing, adhesive, and construction applications."
},
{
  names: ["Tools", "Hand Tools", "SPIRIT LEVEL"],
  title: "Spirit Levels Suppliers in UAE | Construction Tools Dubai | Buraq Star Trading",
  description: "Precision spirit levels in UAE for accurate alignment and leveling in construction and DIY projects."
},
{
  names: ["Tools", "Hand Tools", "STAPLER GUN"],
  title: "Stapler Guns Suppliers in UAE | Upholstery Tools Dubai | Buraq Star Trading",
  description: "Durable stapler guns in UAE for upholstery, woodworking, and industrial fastening applications."
},
{
  names: ["Tools", "Hand Tools", "TOOLS BOX"],
  title: "Tool Boxes Suppliers in UAE | Storage Solutions Dubai | Buraq Star Trading | Novex | Cavil | Zilco",
  description: "Durable tool boxes in UAE for organizing hand tools, power tools, and accessories efficiently."
},
{
  names: ["Tools", "Hand Tools", "TOOLS KIT"],
  title: "Tool Kits Suppliers in UAE | Professional Tool Sets Dubai | Buraq Star Trading | Novex | Cavil | Zilco",
  description: "Complete tool kits in UAE for DIY, professional, and industrial applications. Durable and reliable sets."
},
{
  names: ["Tools", "Hand Tools", "WRENCH"],
  title: "Wrenches Suppliers in UAE | Mechanical Tools Dubai | Buraq Star Trading | Novex | Cavil | Zilco",
  description: "High-quality wrenches in UAE for mechanical, plumbing, and industrial repair work."
},
{
  names: ["Tools", "Hand Tools", "WRENCH - ADJUSTABLE"],
  title: "Adjustable Wrenches Suppliers in UAE | Hand Tools Dubai | Buraq Star Trading | Novex | Cavil | Zilco",
  description: "Versatile adjustable wrenches in UAE for tightening and loosening bolts in all applications."
},
{
  names: ["Tools", "Hand Tools", "WRENCH - ROUND JAW LOCK"],
  title: "Round Jaw Lock Wrenches Suppliers in UAE | Plumbing Tools Dubai | Buraq Star Trading",
  description: "Durable round jaw lock wrenches in UAE for plumbing, mechanical, and industrial applications."
},
{
  names: ["Tools", "Hand Tools", "WRENCH - SET"],
  title: "Wrench Sets Suppliers in UAE | Complete Tool Kits Dubai | Buraq Star Trading | Novex | Cavil | Zilco",
  description: "Premium wrench sets in UAE for professional, industrial, and DIY mechanical work."
},

// Deals / Collections
{
  names: ["Hot Selling"],
  title: "Hot Selling Products in UAE | Best Deals Dubai | Buraq Star Trading | Novex | Cavil | Zilco",
  description: "Discover best-selling products in UAE. High-demand tools and hardware trusted by customers across Dubai and beyond."
},
{
  names: ["Flash Sale"],
  title: "Flash Sale Deals in UAE | Limited Time Offers Dubai | Buraq Star Trading | Novex | Cavil | Zilco",
  description: "Grab limited-time flash sale deals in UAE. Premium products at discounted prices. Shop fast before offers end!"
},
{
  names: ["New Arrival"],
  title: "New Arrivals in UAE | Latest Products Dubai | Buraq Star Trading | Novex | Cavil | Zilco",
  description: "Explore new arrivals in UAE. Fresh, innovative, and high-quality products for industrial, home, and commercial use."
}
]
export const BRAND_SEO_CONFIG = [
  {
    slug: null,
    title: "Electrical, Hardware & Sanitary Suppliers in UAE | Buraq Star Trading | Novex | Cavil | Zilco",
    description:
      "Discover premium electrical, hardware, sanitary, and tools brands in UAE. Shop trusted products from Buraq, Novex, Cavil, Zilco and more at Buraq Star Trading."
  },
  {
    slug: "buraq",
    title: "Buraq Products Supplier in UAE | Electrical, Hardware & Tools",
    description:
      "Shop Buraq brand products in UAE at Buraq Star Trading. High-quality electrical, hardware, sanitary, and industrial solutions trusted across Dubai and UAE."
  },
  {
    slug: "cavil",
    title: "Cavil Products Supplier in UAE | Lighting & Electrical Solutions",
    description:
      "Explore Cavil products in UAE at Buraq Star Trading. Premium lighting, electrical, hardware, and plumbing solutions built for durability and performance."
  },
  // {
  //   slug: "kenwel",
  //   title: "Kenwel Tools & Electrical Products Supplier in UAE",
  //   description:
  //     "Buy Kenwel products in UAE at Buraq Star Trading. Reliable tools and electrical equipment for construction, maintenance, and industrial use."
  // },
  // {
  //   slug: "khaleegia",
  //   title: "Khaleegia Sanitary & Hardware Products in UAE",
  //   description:
  //     "Discover Khaleegia products in UAE at Buraq Star Trading. High-quality sanitary, plumbing, hardware, and electrical solutions for all applications."
  // },
  {
    slug: "novex",
    title: "Novex Electrical, Tools & Lighting Products UAE Supplier",
    description:
      "Shop Novex products in UAE at Buraq Star Trading. Premium electrical, tools, lighting, and accessories designed for industrial and commercial use."
  },
  {
    slug: "zilco",
    title: "Zilco Tools & Electrical Products Supplier in UAE",
    description:
      "Explore Zilco products in UAE at Buraq Star Trading. Trusted tools, hardware, and electrical solutions for professional and industrial applications."
  }
];


export const DEALS_SEO_CONFIG = [
  {
    slug: "hot-selling",
    title: "Hot Selling Products in UAE | Best Deals on Electrical, Hardware & Tools | Buraq Star Trading",
    description:
      "Discover hot selling products in UAE at Buraq Star Trading. Shop top-rated electrical, hardware, sanitary, and tools trusted by customers across Dubai and UAE."
  },
  {
    slug: "flash-sale",
    title: "Flash Sale Deals in UAE | Electrical & Hardware Discounts | Buraq Star Trading",
    description:
      "Grab limited-time flash sale deals at Buraq Star Trading UAE. Save big on premium electrical, hardware, tools, and sanitary products from top brands."
  },
  {
    slug: "new-arrival",
    title: "New Arrivals in UAE | Latest Electrical & Hardware Products | Buraq Star Trading",
    description:
      "Explore new arrivals at Buraq Star Trading UAE. Discover the latest electrical, hardware, sanitary, and tools products with modern design and premium quality."
  }
];
// =====================
// SEO KEY NORMALIZER (ONLY ONCE)
// =====================
export const normalizeSeoKey = (value = "") =>
  value
    .toString()
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/&/g, "and")
    .trim();


// =====================
// CATEGORY MAP
// =====================
export const CATEGORY_SEO_MAP = CATEGORY_SEO_CONFIG.reduce((acc, entry) => {
  const keySource =
    entry.names?.length > 0
      ? entry.names.join(" > ")
      : "categories";

  const key = normalizeSeoKey(keySource);

  if (acc[key]) {
    console.warn("Duplicate SEO key detected:", key, entry);
  }

  acc[key] = entry;
  return acc;
}, {});


// =====================
// BRAND MAP
// =====================
export const BRAND_SEO_MAP = BRAND_SEO_CONFIG.reduce((acc, entry) => {
  const key = normalizeSeoKey(entry.slug || "default");

  if (acc[key]) {
    console.warn("Duplicate BRAND slug detected:", key);
  }

  acc[key] = entry;
  return acc;
}, {});


// =====================
// DEALS MAP
// =====================
export const DEALS_SEO_MAP = DEALS_SEO_CONFIG.reduce((acc, entry) => {
  const key = normalizeSeoKey(entry.slug || "default");

  if (acc[key]) {
    console.warn("Duplicate DEAL slug detected:", key);
  }

  acc[key] = entry;
  return acc;
}, {});